import { ModuleOutput } from 'module/model/module.output';
import { Module } from 'module/module';

export abstract class ModuleConverterPort {
	public abstract moduleAsEntity(output: ModuleOutput): Module;

	public abstract modulesAsEntities(outputs: ModuleOutput[]): Module[];
}
